export const NCDIPO = "NCDIPO";
export const NCDIPO_ADD_MSG = "NCDIPO_ADD_MSG";
export const NCDIPO_CLEAR_MSG = "NCDIPO_CLEAR_MSG";
export const NCDIPO_ERROR = "NCDIPO_ERROR";
export const NCDIPO_HIDE_ERROR = "NCDIPO_HIDE_ERROR";
export const NCDIPO_START_LOADER = "NCDIPO_START_LOADER";
export const NCDIPO_STOP_LOADER = "NCDIPO_STOP_LOADER";
